import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import CustomInput from '../../../../components/common/Input/input';
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb';
import './aprovar-evento.scss'
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Flex,
  Heading,
  Box,
  Button,
  FormLabel,
  FormControl,
  Select,
  Stack,
  Checkbox,
  Spinner,
  RadioGroup,
  Radio,
  Wrap,
  TagLabel,
  Tag,
  WrapItem,
  Tooltip,
  Switch,
  HStack
} from '@chakra-ui/react';
import { FileWithPath } from 'react-dropzone';
import * as api from '../../../../api/evento';
import * as apiPendencia from '../../../../api/pendencia';
import CustomTextArea from '../../../../components/common/Textarea/textArea';
import Swal from 'sweetalert2';
import { listarCategoriasAtivas } from '../../../../api/categoria';
import { ImageDropzoneDisabled } from '../../../../components/common/imageDropzoneDisabled/imageDropzoneDisabled';
import { FaPlus } from 'react-icons/fa';

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

const AprovarEvento: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const today = new Date().toISOString().split('T')[0];

  const [formValues, setFormValues] = useState<{
    titulo: { value: string; error: boolean };
    data: { value: typeof today; error: boolean };
    dataFim: { value: ''; error: boolean };
    dataInicioEvento: { value: ''; error: boolean };
    dataFimEvento: { value: ''; error: boolean };
    horaInicioEvento: { value: ''; error: boolean };
    horaFimEvento: { value: ''; error: boolean };
    numSemHorario: { value: boolean; error: boolean };
    imagem: { value: string; error: boolean };
    dscResumo: { value: string; error: boolean };
    enderecoInternet: { value: string; error: boolean };
    endereco: { value: string; error: boolean };
    creditoAutorNoticia: { value: string; error: boolean };
    creditoAutorImagem: { value: string; error: boolean };
    descricaoImagem: { value: string; error: boolean };
    texto: { value: string; error: boolean };
    seqCategoria: { value: any; error: boolean };
    paginaId: { value: any[]; error: boolean };
    usuarioId: { value: any; error: boolean };
    exigeAprovacao: { value: number; error: boolean };

  }>({
    titulo: { value: '', error: false },
    data: { value: today, error: false },
    dataFim: { value: '', error: false },
    dataInicioEvento: { value: '', error: false },
    dataFimEvento: { value: '', error: false },
    horaInicioEvento: { value: '', error: false },
    horaFimEvento: { value: '', error: false },
    numSemHorario: { value: false, error: false },
    imagem: { value: '', error: false },
    dscResumo: { value: '', error: false },
    enderecoInternet: { value: '', error: false },
    endereco: { value: '', error: false },
    creditoAutorNoticia: { value: '', error: false },
    creditoAutorImagem: { value: '', error: false },
    descricaoImagem: { value: '', error: false },
    texto: { value: '', error: false },
    seqCategoria: { value: '', error: false },
    paginaId: { value: [], error: false },
    usuarioId: { value: null, error: false },
    exigeAprovacao: { value: 0, error: false },
  });

  const [imageBase64, setImageBase64] = useState<string>('');
  const [paginas, setPaginas] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true);
  const [selectedPages, setSelectedPages] = useState<number[]>([]);
  const [seqUsuario, setSeqUsuario] = useState<any[]>([]);
  const [removedPages, setRemovedPages] = useState<number[]>([]);
  const [categorias, setCategorias] = useState<any[]>([]);
  const [aprovadores, setAprovadores] = useState<any[]>([]);
  const [selectedUser, setSelectedUser] = useState<number | null>(null);
  const [executor, setExecutor] = useState<any[]>([]);
  const [isReprovandoButton, setReprovandoButton] = useState<boolean>(false);
  const [isAprovandoButton, setAprovandoButton] = useState<boolean>(false);
  const [tagUsuario, setTagUsuario] = useState<string>('');

  const fetchEventoData = async () => {
    setIsLoading(true);
    try {
      const eventoData = await api.obterEvento(Number(id));
      const { nomePublicacao, datPublicacao, datDespublicar, datInicioEvento, datFimEvento, dscCreditoImagem, dscCreditoNoticia, seqCategoria, conteudoPaginaDTO, binPublicacao, urlBin, dscEnderecoEvento, dscResumo, dscPublicacao, dscHoraInicioEvento, dscHoraFimEvento, numSemHorario, pendencia, dscCitacaoUsuario } = eventoData;

      let exigeAprovacaoValue = 0;

      setExecutor(eventoData.pendencia.seqExecutor)

      if (pendencia && pendencia.seqSolicitante) {
        exigeAprovacaoValue = 1;
        setSelectedUser(pendencia.seqExecutor);
      }
      const usuarioIdValue = pendencia?.seqExecutor;

      const userTagsArray = (dscCitacaoUsuario || '')
        .split(' ')
        .filter((tag: any) => tag.startsWith('@'));
      setTagUsuario(userTagsArray.join(' '));

      setFormValues({
        titulo: { value: nomePublicacao, error: false },
        data: { value: datPublicacao || today, error: false },
        dataFim: { value: datDespublicar || '', error: false },
        dataInicioEvento: { value: datInicioEvento || '', error: false },
        dataFimEvento: { value: datFimEvento || '', error: false },
        horaInicioEvento: { value: dscHoraInicioEvento || '', error: false },
        horaFimEvento: { value: dscHoraFimEvento || '', error: false },
        numSemHorario: { value: numSemHorario, error: false },
        imagem: { value: binPublicacao || '', error: false },
        endereco: { value: dscEnderecoEvento || '', error: false },
        creditoAutorImagem: { value: dscCreditoImagem || '', error: false },
        descricaoImagem: { value: '', error: false },
        seqCategoria: { value: seqCategoria || '', error: false },
        paginaId: { value: conteudoPaginaDTO.map((item: any) => item.seqPagina.toString()), error: false },
        usuarioId: { value: usuarioIdValue, error: false },
        exigeAprovacao: { value: exigeAprovacaoValue, error: false },
        dscResumo: { value: dscResumo || '', error: false },
        enderecoInternet: { value: urlBin || '', error: false },
        creditoAutorNoticia: { value: dscCreditoNoticia || '', error: false },
        texto: { value: dscPublicacao || '', error: false },
      });

    } catch (error) {
      console.error("Erro ao buscar dados do banner:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchPaginas = async () => {
    try {
      const data = await api.paginasAtivas();
      setPaginas(data);
    } catch (error) {
      console.error('Erro ao buscar páginas ativas:', error);
    }
  };

  const fetchAprovadoresAtivos = async () => {
    try {
      const data = await api.listarExecutores();
      setAprovadores(data);
    } catch (error) {
      console.error('Erro ao buscar lista de executores para aprovação:', error);
    }
  };

  useEffect(() => {
    const storedUsuario = localStorage.getItem('dadosUsuario');
    if (storedUsuario) {
      try {
        const usuario = JSON.parse(storedUsuario);
        setSeqUsuario(usuario.seqUsuario);

      } catch (error) {
        console.error("Erro ao recuperar os dados do usuário:", error);
      }
    }

    const fetchCategorias = async () => {
      try {
        const data = await listarCategoriasAtivas();
        setCategorias(data);
      } catch (error) {
        console.error('Erro ao buscar categorias ativas:', error);
      }
    };

    fetchCategorias();
    fetchEventoData();
    fetchPaginas();
    fetchAprovadoresAtivos();
  }, []);

  const handleFieldChange = (field: keyof typeof formValues, value: any) => {
    setFormValues({ ...formValues, [field]: { value, error: false } });
  };

  const handleInputRadioChange = (field: string, value: any) => {
    if (field === 'exigeAprovacao' && value === 0) {
      setFormValues({
        ...formValues,
        [field]: { error: false, value },
        usuarioId: { value: null, error: false }
      });
    } else {
      setFormValues({
        ...formValues,
        [field]: { error: false, value }
      });
    }
  };

  const handleRadioChange = (seqUsuario: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;

    setSelectedUser(isChecked ? seqUsuario : null);

    setFormValues((prevValues: any) => {
      const updatedUsuarioIdValue = isChecked ? seqUsuario : null;

      return {
        ...prevValues,
        usuarioId: { value: updatedUsuarioIdValue },
      };
    });
  };

  const handleCheckboxChange = (seqPagina: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;

    setSelectedPages((prev) => {
      const updatedPages = isChecked ? [...prev, seqPagina] : prev.filter((id) => id !== seqPagina);
      return updatedPages;
    });

    if (isChecked) {
      setRemovedPages(prev => prev.filter(id => id !== seqPagina));
    } else {
      setRemovedPages(prev => [...prev, seqPagina]);
    }

    setFormValues((prevValues: any) => {
      const updatedPaginaIdValue = isChecked
        ? [...prevValues.paginaId.value, seqPagina.toString()]
        : prevValues.paginaId.value.filter((id: string) => id !== seqPagina.toString());

      return {
        ...prevValues,
        paginaId: { value: updatedPaginaIdValue },
      };
    });
  };

  const handleImageSelected = async (selected: FileWithPath | null) => {
    if (selected) {
      const image = await createImage(selected);
      const resizedImage = await convertTamanhoImagem(image, 300, 300);

      if (resizedImage) {
        const base64Image = await convertBase64(resizedImage);

        const base64Data = base64Image.split(',')[1];

        setImageBase64(base64Data);
      } else {
        setImageBase64('');
        console.error('Erro ao redimensionar a imagem.');
      }
    } else {
      setImageBase64('');
    }
  };

  const createImage = (file: File) => {
    return new Promise<HTMLImageElement>((resolve) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => resolve(img);
    });
  };

  const convertTamanhoImagem = (image: HTMLImageElement, width: number, height: number) => {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      ctx.drawImage(image, 0, 0, width, height);
    }

    return new Promise<Blob | null>((resolve) => {
      canvas.toBlob((blob) => {
        if (blob) {
          const img = new Image();
          img.src = URL.createObjectURL(blob);
          img.onload = () => {
            resolve(blob);
          };
        } else {
          resolve(null);
        }
      }, 'image/*');
    });
  };

  const convertBase64 = async (file: Blob): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result as string);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setAprovandoButton(true);

    const params = Number(id);

    try {
      await apiPendencia.aprovarConteudo(params);
      setAprovandoButton(false);
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Publicação aprovada com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/inicio/visualizacao-necessidade-atuacao');
      });
    } catch (error) {
      setAprovandoButton(false);
      console.error('Erro ao aprovar publicação:', error);
      Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: 'Erro ao aprovar publicação. Tente novamente mais tarde.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/inicio/visualizacao-necessidade-atuacao');
      });
    }
  };

  const handleReprovarPublicacao = async () => {

    const { usuarioId } = formValues;

    const motivoReprovacao = await Swal.fire({
      input: 'textarea',
      width: '50%',
      title: 'Qual é o motivo da reprovação?',
      inputPlaceholder: 'Digite o motivo da reprovação aqui',
      inputAttributes: {
        'aria-label': 'Digite o motivo da reprovação aqui'
      },
      reverseButtons: true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Enviar Motivo',
      confirmButtonColor: '#1665D8',
      cancelButtonColor: '#EDF2F7',
      didOpen: () => {
        const confirmButton = Swal.getConfirmButton();
        if (confirmButton) {
          confirmButton.disabled = true;
          const input = Swal.getInput();
          if (input) {
            input.addEventListener('input', () => {
              confirmButton.disabled = input.value.trim().length < 1;
            });
          }
        }
      },
    });

    if (motivoReprovacao.isConfirmed) {
      setReprovandoButton(true);
      const params = {
        pendencia: {
          codPendencia: 1,
          seqSolicitante: seqUsuario,
          seqExecutor: usuarioId.value,
          dscObs: motivoReprovacao.value,
        }
      };

      try {
        await apiPendencia.reprovarConteudo(Number(id), params);
        setReprovandoButton(false);
        await Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'A publicação foi reprovada com sucesso.',
          confirmButtonColor: '#1789FC',
          confirmButtonText: 'OK',
        });
        navigate('/cms/inicio/visualizacao-necessidade-atuacao');
      } catch (error) {
        setReprovandoButton(false);
        console.error('Erro ao reprovar publicação:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Erro!',
          text: 'Ocorreu um erro ao reprovar a publicação. Tente novamente.',
          confirmButtonColor: '#1789FC',
          confirmButtonText: 'OK',
        });
        navigate('/cms/inicio/visualizacao-necessidade-atuacao');
      }
    }
  };

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      < SettingsBreadcrumb />
      <Heading mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Aprovar Evento
      </Heading>
      {isLoading ? (
        <Flex
          justify="center"
          align="center"
          direction="column"
          w="70%"
          h="90%"
          position='fixed'
        >
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : (

        <Box m="40px 0" w="100%">
          <form onSubmit={handleFormSubmit}>
            <div className="row">
              <div className="col-md-6 mb-4">
                <FormControl isRequired isInvalid={formValues.seqCategoria.error}>
                  <FormLabel mb="8px">Categoria do Evento</FormLabel>
                  <Select
                    disabled={true}
                    className='opacidade'
                    placeholder='Selecione uma Categoria'
                    borderColor="gray.300"
                    _hover={{ borderColor: 'blue.500' }}
                    value={formValues.seqCategoria.value}
                    onChange={(e) => handleFieldChange('seqCategoria', e.target.value)}
                  >
                    {categorias.length > 0 ? (
                      categorias.map(categoria => (
                        <option key={categoria.seqCategoria} value={categoria.seqCategoria}>
                          {categoria.dscCategoria}
                        </option>
                      ))
                    ) : (
                      <option disabled>Sem categorias disponíveis</option>
                    )}
                  </Select>
                </FormControl>
              </div>

              <div className="col-md-6 mb-4">
                <FormControl isRequired isInvalid={formValues.titulo.error}>
                  <FormLabel mb="8px">Título do Evento</FormLabel>
                  <CustomInput
                    isDisabled={true}
                    className='opacidade'
                    placeholder="Digite um título"
                    value={formValues.titulo.value}
                    onChange={(e: any) => handleFieldChange('titulo', e.target.value)}
                  />
                </FormControl>
              </div>

              <div className="col-md-6 mb-4">
                <FormControl mb={'24px'}>
                  <FormLabel mb="8px">Endereço do Evento</FormLabel>
                  <CustomInput
                    isDisabled={true}
                    className='opacidade'
                    placeholder="Digite um endereço"
                    value={formValues.endereco.value}
                    onChange={(e) => handleFieldChange('endereco', e.target.value)}
                  />
                </FormControl>

                <div className="row" style={{ marginBottom: '24px' }}>
                  <div className="col-md-6">
                    <FormControl isRequired>
                      <FormLabel mb="8px">Data início do evento</FormLabel>
                      <CustomInput
                        isDisabled={true}
                        className='opacidade'
                        id="event-approve-start-date"
                        type="date"
                        value={formValues.dataInicioEvento.value}
                        onChange={(e: any) => handleFieldChange('dataInicioEvento', e.target.value)}
                      />
                    </FormControl>
                  </div>

                  <div className="col-md-6">
                    <FormControl>
                      <FormLabel mb="8px">Data fim do evento</FormLabel>
                      <CustomInput
                        isDisabled={true}
                        className='opacidade'
                        id="event-approve-end-date"
                        type="date"
                        value={formValues.dataFimEvento.value}
                        onChange={(e) => handleFieldChange('dataFimEvento', e.target.value)}
                      />
                    </FormControl>
                  </div>
                </div>
                <Stack spacing={4} mb='24px'>
                <FormControl display="flex" alignItems="center">
                  <Switch
                    id="dia-todo"
                    isChecked={formValues.numSemHorario.value}
                    onChange={e => handleFieldChange('numSemHorario', e.target.checked)}
                    disabled={true}
                  />
                  <FormLabel htmlFor="dia-todo" mb="0" ml="8px">
                    Evento o dia todo
                  </FormLabel>
                </FormControl>

                <HStack spacing={6} width="100%">
                  <FormControl flex="1" isRequired={!formValues.numSemHorario.value}>
                    <FormLabel mb="8px">Horário de início</FormLabel>
                    <CustomInput
                      isDisabled={true}
                      className='opacidade'
                      id="end-time"
                      type="time"
                      value={formValues.horaInicioEvento.value}
                      onChange={(e) => handleFieldChange('horaInicioEvento', e.target.value)}
                    />
                  </FormControl>

                  <FormControl flex="1" isRequired={!formValues.numSemHorario.value}>
                    <FormLabel mb="8px">Horário de término</FormLabel>
                    <CustomInput
                      isDisabled={true}
                      className='opacidade'
                      id="end-time"
                      type="time"
                      value={formValues.horaFimEvento.value}
                      onChange={(e) => handleFieldChange('horaFimEvento', e.target.value)}
                    />
                  </FormControl>
                </HStack>
              </Stack>

                <div className="col-md-12 mb-4">
                  <FormControl className='mb-4'>
                    <FormLabel mb="8px">Imagem miniatura</FormLabel>
                    <ImageDropzoneDisabled
                      base64={formValues.imagem.value || ''}
                    />
                    <input
                      id="image-upload"
                      type="file"
                      style={{ display: 'none' }}
                      accept="image/jpeg, image/png"
                      onChange={(e) => handleImageSelected(e.target.files ? e.target.files[0] : null)}
                    />

                    {imageBase64 && (
                      <FormControl isRequired className="mt-3">
                        <FormLabel mb="8px">Crédito/Autor da imagem</FormLabel>
                        <CustomInput
                          isDisabled={true}
                          className='opacidade'
                          placeholder="Digite um crédito ou autor da imagem"
                          value={formValues.creditoAutorImagem.value}
                          onChange={(e) => handleFieldChange('creditoAutorImagem', e.target.value)}
                        />
                      </FormControl>
                    )}

                  </FormControl>

                  <input
                    id="image-upload"
                    type="file"
                    style={{ display: 'none' }}
                    accept="image/jpeg, image/png"
                    onChange={(e) => handleImageSelected(e.target.files ? e.target.files[0] : null)}
                  />
                </div>

                <FormControl mt={'24px'}>
                  <Flex justify="space-between" align="center" mb="8px">
                    <FormLabel mb="8px">
                      Escolha em quais páginas a Evento deve aparecer <span style={{ color: 'red' }}>*</span>
                    </FormLabel>
                  </Flex>
                  <div className="sidebar-checkbox-pagina">
                    <Stack spacing={5}>
                      {paginas.length > 0 ? (
                        paginas.map((pagina: any) => (
                          <Flex key={pagina.seqPagina} align="center" justify="space-between" direction={{ base: 'column', md: 'row' }}>
                            <Checkbox
                              disabled={true}
                              sx={{
                                '.chakra-checkbox__label': {
                                  opacity: 1,
                                  userSelect: 'none',
                                },
                              }}
                              className="checkPaginasNoticia"
                              isChecked={formValues.paginaId.value.includes(pagina.seqPagina.toString())}
                              onChange={(e) => handleCheckboxChange(pagina.seqPagina, e)}
                            >
                              {pagina.nomPagina}
                            </Checkbox>
                          </Flex>
                        ))
                      ) : (
                        <p>Não há páginas disponíveis.</p>
                      )}
                    </Stack>
                  </div>
                </FormControl>
              </div>

              <Box className='col-md-6'>
                <div className='row'>
                  <div className="col-md-6 mb-4">
                    <FormControl isRequired>
                      <FormLabel mb="8px">Data para Publicação</FormLabel>
                      <CustomInput
                        isDisabled={true}
                        className='opacidade'
                        id="event-approve-publication-date"
                        type="date"
                        value={formValues.data.value}
                        onChange={(e) => handleFieldChange('data', e.target.value)}
                      />
                    </FormControl>
                  </div>
                  <div className="col-md-6 mb-4">
                    <FormControl>
                      <FormLabel mb="8px">Data fim para Publicação</FormLabel>
                      <CustomInput
                        isDisabled={true}
                        className='opacidade'
                        id="event-approve-unpublish-date"
                        type="date"
                        value={formValues.dataFim.value}
                        onChange={(e) => handleFieldChange('dataFim', e.target.value)}
                        min={today}
                      />
                    </FormControl>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12 mb-4">
                    <FormControl>
                      <FormLabel mb="8px">Resumo do evento</FormLabel>
                      <CustomTextArea
                        isDisabled={true}
                        className='opacidade'
                        placeholder="Digite um resumo"
                        value={formValues.dscResumo.value}
                        onChange={(e) => handleFieldChange('dscResumo', e.target.value)}
                        height={'136px'}
                      />
                    </FormControl>
                  </div>
                </div>

                <FormControl>
                  <FormLabel mb="8px">Tags</FormLabel>
                </FormControl>
                <div className="rolagem-hashtag mb-2">
                  {tagUsuario && tagUsuario.trim().length > 0 ? (
                    <Wrap spacing="2px">
                      {tagUsuario.split(" ").map((tag, index) => (
                        <WrapItem key={index}>
                          <Tooltip label={tag} placement="top" hasArrow>
                            <Tag variant="solid" colorScheme="blue" maxW="180px" isTruncated>
                              <TagLabel>{tag}</TagLabel>
                            </Tag>
                          </Tooltip>
                        </WrapItem>
                      ))}
                    </Wrap>
                  ) : (
                    <p>Não há tags</p>
                  )}
                </div>


                <FormControl marginBottom={'24px'}>
                  <FormLabel mb="8px">Endereço de Internet para o evento</FormLabel>
                  <CustomInput
                    isDisabled={true}
                    className='opacidade'
                    placeholder="Digite um endereço de internet"
                    value={formValues.enderecoInternet.value}
                    onChange={(e) => handleFieldChange('enderecoInternet', e.target.value)}
                  />
                </FormControl>

                <div className="row mt-2">
                  <div className="col-md-6 mb-4">
                    <FormControl isRequired>
                      <FormLabel mb="8px">Exige aprovação</FormLabel>
                      <RadioGroup
                        isDisabled={true}
                        className='opacidade'
                        mt={3.5}
                        onChange={(value) => handleInputRadioChange('exigeAprovacao', Number(value))}
                        value={formValues.exigeAprovacao.value.toString()}
                      >
                        <Radio value="1" mr={5}>Sim</Radio>
                        <Radio value="0">Não</Radio>
                      </RadioGroup>
                    </FormControl>
                  </div>

                  {formValues.exigeAprovacao.value === 1 && (
                    <div className="col-md-6 mb-4">
                      <FormControl isRequired>
                        <FormLabel mb="8px">Selecione o aprovador desta publicação</FormLabel>
                        <div className={`input-radio-lista ${aprovadores.length === 0 ? 'escondida' : ''}`}>
                          <Stack spacing={5}>
                            {aprovadores.length > 0 ? (
                              aprovadores.map((aprovador: any) => (
                                <Flex key={aprovador.seqUsuario} align="center" justify="space-between" direction="row">
                                  <Radio
                                    isDisabled={true}
                                    className='opacidade'
                                    value={aprovador.seqUsuario.toString()}
                                    isChecked={selectedUser === aprovador.seqUsuario}
                                    onChange={(e) => handleRadioChange(aprovador.seqUsuario, e)}
                                  >
                                    {aprovador.dscNome}
                                  </Radio>
                                </Flex>
                              ))
                            ) : (
                              <p>Não há lista de aprovadores disponíveis.</p>
                            )}
                          </Stack>
                        </div>
                      </FormControl>
                    </div>
                  )}
                </div>
              </Box>
            </div>

            <Flex justifyContent="end">
              <Button
                m="6px"
                onClick={handleReprovarPublicacao}
                isDisabled={executor != seqUsuario}
                isLoading={isReprovandoButton}
                loadingText="Reprovando Publicação..."
              >
                Reprovar Publicação
              </Button>
              <Button
                type="submit"
                m="6px"
                color="#FFF"
                bgColor="#1665D8"
                _hover={{ opacity: 0.8 }}
                isDisabled={executor != seqUsuario}
                isLoading={isAprovandoButton}
                loadingText="Aprovando Publicação..."
              >
                Aprovar Publicação
              </Button>
            </Flex>
            <Flex hidden={executor == seqUsuario} justifyContent="end">
              <p className='mansagem-erro-executor'>
                Você não é o aprovador desta publicação.
              </p>
            </Flex>
          </form>
        </Box>
      )}
    </Flex>
  );
};

export default AprovarEvento;
